const CATEGORIES = ["CINEMATOGRAPHY", "EDITING", "SOUND", "MOTION GRAPHICS", "PRODUCTION WORKFLOW", "COLOR"];

export default function CategoryStrip() {
  const row = [...CATEGORIES, ...CATEGORIES];
  return (
    <div className="bg-lima-blue overflow-hidden py-3.5 select-none border-y border-black" data-testid="category-strip">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((c, i) => (
              <span key={i} className="flex items-center font-mono2 text-[11px] md:text-xs tracking-[0.3em] text-white">
                <span className="px-6 md:px-10">{c}</span>
                <span className="text-white/60 text-[10px]" aria-hidden="true">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
